export const REQUESTED_2FA_TIME = 'requested-2fa-time'
export const AUTHENTICATED_2FA_TIME = 'authenticated-2fa-time'
